<template >
    <section>
        <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
        <div class="row">
            <div class="col-10 offset-1 px-4">
                <div class="row align-items-center justify-content-end">
                    <div class="col">
                        <nav aria-label="breadcrumb">
                            <ul class="breadcrumb mt-5">
                                <li class="breadcrumb-item h3 font-weight-bold mb-0 active" aria-current="page">
                                    {{ gradeSubject.grade.name  }} - {{ gradeSubject.subject.name  }}
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-auto ml-auto">
                        <router-link v-bind:to="{name: 'material/index'}" class="btn btn-danger btn-sm">
                            <i class="fa fa-chevron-left mr-2"></i> Kembali ke List Materi
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Deskripsi Umum
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col" v-html="gradeSubject.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                    <div class="col-12" v-for="(material, index) in materials" :key="material.id">
                        <div class="card shadow-sm mb-4 border-0">
                        <b-button block variant="link" class="text-left text-danger" v-bind:pressed.sync="states[index]" v-b-toggle="'accordion-' + index">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col text-truncate h3 mb-0 font-weight-light">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            {{ material.title }}
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                            <i class="fa fa-lg" v-bind:class="states[index] ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i>
                                    </div>
                                </div>
                            </div>
                        </b-button>
                        <b-collapse v-model="states[index]" v-bind:id="'accordion-' + index">
                            <div class="card-body">
                                <div class="card-title text-muted mb-0">
                                    Judul:
                                </div>
                                <p class="mb-2">
                                    {{ material.title }}
                                </p>
                                <div class="card-title text-muted mb-0">
                                    Deskripsi:
                                </div>
                                <div class="row">
                                    <div class="col" v-html="material.description"></div>
                                </div>
                                <div class="card-title text-muted mb-0">
                                    File:
                                </div>
                                <ol class="pl-4">
                                    <li v-for="file in material.teachingMaterialFiles" :key="file.id">
                                        <a href="#" v-on:click.prevent="download(file)" class="h4 font-weight-bold text-dark p-0 mb-0">
                                            <file-icon v-bind:type="file.fileExtension" class="mr-1"></file-icon> {{ file.filename }}
                                        </a>
                                        <p class="text-muted mb-1">
                                            {{ file.description }}
                                        </p>
                                    </li>
                                </ol>
                                <div class="card-title text-muted mb-0">
                                    Video:
                                </div>
                                <div class="row text-center">
                                    <div class="col-4" v-for="video in material.teachingMaterialVideos" :key="video.id">
                                        <button type="button" class="btn btn-link p-0" v-on:click="videoReference = video">
                                            <img v-bind:src="'https://img.youtube.com/vi/' + video.url + '/0.jpg'" class="img-fluid" />
                                        </button>
                                        <p class="text-center">
                                            {{ video.description }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <b-modal v-model="modal" v-on:hide="videoReference = null" modal-class="border-0" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true" v-bind:hide-header="true" body-class="p-0 bg-black" size="lg">
            <div v-if="videoReference" class="embed-responsive embed-responsive-16by9">
                <youtube v-bind:video-id="videoReference.url" ref="youtube" v-on:playing="watch(videoReference)" class="embed-responsive-item" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></youtube>
            </div>    
        </b-modal>
	    <div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import FileIcon from "@/components/item/FileIcon";
    import qs from 'qs';

    export default {
        name: "MaterialView",
        components: {
            FileIcon
        },
        computed: {
            player() {
                return this.$refs.youtube.player;
            }
        },
        watch: {
            videoReference(videoReference) {
                if (videoReference) {
                    this.modal = true;
                } else {
                    this.watched = false;
                }
            }
        },
        data() {
            return {
                gradeSubject: {subject: {}, grade: {}},
                materials: [],
                modal: false,
                videoReference: null,
		states: [],		
		googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                watched: false
            };
        },
        methods: {
            download(file) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/teaching-material/download-file/' + file.id + '?' + qs.stringify({token: token}, {encode: false});
            },
            watch(video) {
                if (!this.watched) {
                    this.axios.post(process.env.API_URL + '/teaching-material/video/' + video.id + '/logs').then(response => {
                        this.watched = true;
                        console.log(response);
                    });
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade-subject/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/teaching-material', {params: {gradeSubjectID: this.$route.params.id}})
            ]).then(this.axios.spread(function (responseGradeSubject, responseMaterial) {
                this.gradeSubject = responseGradeSubject.data.data;
                this.materials = responseMaterial.data.data;

                document.title = 'Materi Bahan Ajar: ' + this.gradeSubject.subject.name + ' - ' + process.env.APP_NAME;
            }.bind(this)));
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/material/View.vue